<template>
    <div class="all">

            <div class="banner" >
                <img :src="myInfo.banner" width="100%"/>
            </div>

        <van-row style="margin-top: 1.5rem;margin-bottom: 1.5rem">
            <van-col span="12">

                <van-button round class="button-share-tg" size="normal" v-clipboard:copy=myInfo.inviteCodeUrl
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">复制链接分享
                </van-button>
            </van-col>
            <van-col span="12">
                <div class="button-share-friend" @click="goshare()">海报邀请</div>

            </van-col>

        </van-row>
           <div class="team">
               <van-row>
                   <van-col span="24"><strong>团队概况</strong></van-col>
               </van-row>
            <van-row class="teamData">
                <van-col span="24"><div>{{myInfo.downCount}}</div><span>直接下属</span></van-col>

            </van-row>
               <van-row>
                   <van-col span="24">
                       <div class="button-viewdown">
                           <a href="#/user/group">查看下级列表</a>
                       </div>

                   </van-col>
               </van-row>

        </div>
        <div class="adshare"  id="adshare">
            <van-row class="aditems">
                <van-col span="24" style="text-align:center">
                    <div class="swiper">
                        <swiper :options="swiperOption" ref="mySwiperA">


                            <!-- 幻灯内容 -->
                            <swiper-slide v-for="(scene, index) in myInfo.ads"> <img :src="scene+'&inviteCode='+inviteCode" width="90%"></swiper-slide>


                        </swiper>

                    </div>

                </van-col>

            </van-row>


            <van-row >
                <van-col span="24" style="text-align:center">
                    <div class="button-intro">点击海报长按保存</div>
                </van-col>

            </van-row>
        </div>


    </div>
</template>

<script>
    import userAPI from '@/api/user'
    //页面引入swiper
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                selected: '',
                query: {},
                myInfo:{},
                inviteCode:'',
                swiperOption: {


                    loop:true,
                    slidesPerView: 3,
                    effect: "coverflow",

                    coverflowEffect: {
                        rotate: 0,
                        stretch: -80, // slide左右距离
                        depth: 400, // slide前后距离
                        modifier: 0.5, //
                        slideShadows: false // 滑块遮罩层
                    },



                }



            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiperA.swiper
            }
        },
        created() {
                this.index();

        },
        mounted() {

            this.swiper.slideTo(3, 1000, false);


        },

        methods: {
            index() {
                this.$toast.loading({forbidClick: true})
                userAPI.group(this.query).then((result) => {
                    this.myInfo=result.data;
                    this.inviteCode=result.data.my.inviteCode;
                    console.log(result);
                    this.$toast.clear()
                })
            },
            goshare(){

                document.getElementById("adshare").scrollIntoView();

            },
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('分享链接已经复制到剪切板')
            }


        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #ffe1dc;
    }


    .button-share-tg{
        display: block;
        width: 80%;
        height: 5rem;
        background-image: linear-gradient(90deg, #FFAA09 0%, #FF7104 100%);
        border-radius: 2.5rem;
        margin: auto;
        text-align: center;
        color: #ffffff;
        font-size: 1.5rem;
        line-height: 5rem;
    }

    .button-share-friend{
        width: 80%;
        height: 5rem;
        background-image: linear-gradient(90deg, #63B7FF 0%, #3481FF 100%);
        border-radius: 2.5rem;
        margin: auto;
        text-align: center;
        color: #ffffff;
        font-size: 1.5rem;
        line-height: 5rem;
    }

    .teamData{
        div{

            div{
                text-align: center;
                color: #111111;
                font-size: 3rem;
                margin-top: 3rem;
                margin-left: 5rem;
                margin-right: 5rem;
            }
            span{
                text-align: center;
                color: #858B9C;
                width: 100%;
                display: block;
            }

        }
    }

    .team{
        background-color: #ffffff;
        height: 20rem;
        margin-left: 1rem;
        margin-right: 1rem;
        margin-bottom: 2rem;
        border-radius: 1rem;
        padding: 1rem;
    }

    .button-viewdown{
        color: #1A71FF ;

        width: 20rem;
        height: 4.5rem;
        margin: auto;
        margin-top: 3rem;
        margin-bottom: 4rem;
        border-radius: 3rem;
        font-size: 1.8rem;
        line-height: 4.6rem;
        border-color: #1A71FF ;


        border: 1px solid rgba(26,113,255,1);

        a{
            color: #1A71FF;
            font-size: 2.2rem;
            margin-left: 3.3rem;
        }

    }
    .button-intro{
        color: #ffffff;

        background-image: linear-gradient(90deg, #FFAA09 0%, #FF7104 100%);
        background: -webkit-linear-gradient(90deg, #FFAA09 0%, #FF7104 100%); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(90deg, #FFAA09 0%, #FF7104 100%); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(90deg, #FFAA09 0%, #FF7104 100%); /* Firefox 3.6 - 15 */
        background: linear-gradient(90deg, #FFAA09 0%, #FF7104 100%); /* 标准的语法 */

        width: 80%;
        height: 4.5rem;
        margin: auto;
        margin-top: 3rem;
        margin-bottom: 4rem;
        border-radius: 3rem;
        font-size: 1.8rem;
        line-height: 4.6rem;
    }
    .adshare{
        margin-left: 1rem;
        margin-right: 1rem;
        margin-bottom: 1rem;
        background-image:url("../../../assets/images/ad_bg.png");
       background-size:100% 100%;

    .swiper-wrapper{
        height: 28rem !important;
    }
    .aditems{
        padding-top: 5.5rem;
        width: 90%;
        height: auto;
        margin: auto;



    }
    }
    .header {
        padding: 0.5rem 0.2rem 1rem 0.2rem;
        margin: 0.5rem;
        background-image:url("../../../assets/images/data_bg.png");
        overflow: hidden;
        border-radius: 0.5rem;
        .plan {
            color: #FFFFFF;
            text-align: center;
            .rmb {
                font-size: 1.6rem;
                line-height: 3rem;
            }
            margin-bottom: 1rem;
        }
        .statistics {
            text-align: center;
            margin: 1rem 0.4rem 0.2rem 0.4rem;
            font-size: 1.1rem;
            background-color: #FFFFFF;
            .onehang {
                color: #8b9196;
            }
            .van-row {
                padding: 0.5rem;
                border-bottom: 1px solid #e5e5e5;
            }
            .noData {
                color: #B3B3B3;
                padding: 5rem;
            }
        }

    }

    select {
        float: right;
        text-align: center;
    }

    .center {
        border-top: 4px solid #f2f2f2;

        font-size: 1.1rem;
        padding: 1rem;
        .van-row {
            padding: 0.5rem 0rem;
            border-bottom: 1px solid #f2f2f2;
            span {
                font-size: 1rem;
                color: #8b9196;
            }
        }
        .statistics {
            clear: both;
        }
    }

    .buttom {
        border-top: 4px solid #f2f2f2;
        .van-row {
            margin: 1rem;
            font-size: 1.1rem;
        }

        .table-box {
            height: 16.7rem;
            overflow-x: scroll;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            color: #7d7e80;
            table tr td {
                text-align: center;
                line-height: 1.6rem;
            }
        }

        .van-pagination__item {
            color: #1A71FF;
        }

        .noData {
            width: 6.9rem;
            height: 6.9rem;
            margin: 4rem auto 4rem auto;
            text-align: center;
            color: #E6E6E6;
            i {
                font-size: 5rem;
            }
        }

    }

</style>
